import React, { useState, useEffect } from "react"
// import { useStaticQuery, graphql, Link, withPrefix } from "gatsby"
import { useStaticQuery, graphql, Link, withPrefix } from "gatsby"

import { Twirl as Hamburger } from 'hamburger-react'

import Search from "./search"

import logo from "../images/logo.svg"

// import sidebarStyles from "./sidebar.module.css"

import {
    active as activeStyle,
    doc as docStyle,
    hasItems as hasItemsStyle,
    section as sectionStyle,
    posts as postsStyle,
    categories as categoriesStyle,
    category as categoryStyle,
    sections as sectionsStyle,
    hasPosts as hasPostsStyle,
    menu as menuStyle,
    mobileOpen as mobileOpenStyle,
    header as headerStyle,
    headerTop as headerTopStyle,
    logo as logoStyle,
    hamburger as hamburgerStyle,
    headerSearch as headerSearchStyle,
    content as contentStyle,
    partiallyActiveStyle
} from "./sidebar.module.css"

import { Fragment } from "react"


export default function Sidebar({submenuDataSourceName, postLink}) {

    // console.log("RENDER SIDEBAR")
    // console.log("submenuDataSourceName: ", submenuDataSourceName)

    // console.log("window.history in Sidebar.js ", window.history.state)
    // let activePageName = null
    // // if window.history.state.id passed, we must open the branch
    // if(typeof window !== `undefined` && window.history.state && window.history.state.pageName){
    //     //console.log("ID: ", window.history.state.id)
    //     activePageName = window.history.state.pageName
    // }  

    // console.log("activePageName: ", activePageName)

    const [isOpen, setOpen] = useState(false)

    // handle situation when we need to close mobile menu when clicked outside of hamburger
    useEffect(() => {
        const clickHandler = ({ target }) => {

            if(target.closest('.hamburger-react') || !isOpen || (target.getAttribute("id") === 'search_btn') || target.closest("#search")){
                return
            }

            // close mobile menu
            setOpen(false)
        }

        document.addEventListener("click", clickHandler)

        // these functions clean up the event listeners
        return () => document.removeEventListener("click", clickHandler)
    })      

    const data = useStaticQuery(graphql`
        query {
            allMdx(sort: {frontmatter: {weight: DESC}}) {
                totalCount
                edges {
                    node {
                        id
                        frontmatter {
                            post_title
                            dir
                            weight
                        }
                        fields {
                            slug
                        }    
                        tableOfContents(maxDepth: 2)                    
                    }
                }              
            }         
            allApiJson{
                edges {
                  node {
                    name
                    content {
                      title
                      menu_title
                      method
                      version
                      name
                      description
                      message{
                          type
                          text
                      }
                      request_description
                      code {
                        name
                        example
                      }
                      method_arguments{
                        order
                        name
                        data_type
                        short_description
                        required
                        description                          
                      }          
                      return_object{
                          name
                          order
                          description
                          short_description
                      }                                
                      response
                      response_description
                      input_objects{
                          name
                          description
                          short_description                          
                          attributes{
                            name
                            short_description
                            order
                            data_type
                            required
                            description                         
                            attributes{
                                name
                                order
                                required
                                data_type
                                short_description
                                description
                                message{
                                    type
                                    text
                                }                                  
                                attributes{
                                    name
                                    order
                                    required
                                    data_type
                                    short_description
                                    description                                 
                                    attributes{
                                        name
                                        order
                                        required
                                        data_type
                                        short_description
                                        description                                        
                                    }                                         
                                }                                  
                            }                              
                          }
                      }
                      output_objects{
                          name
                          description
                          data_type                       
                          short_description
                          example                           
                          attributes{
                            name
                            order
                            data_type
                            short_description
                            description                                
                            attributes{
                                name
                                order
                                data_type
                                short_description
                                description    
                                attributes{
                                    name
                                    required
                                    data_type
                                    short_description
                                    description    
                                    attributes{
                                        name
                                        order
                                        required
                                        data_type
                                        short_description
                                        description                                                                     
                                    }                                                                                                        
                                }                                                                                                    
                            }                               
                          }
                      }                     
                    }
                  }
                }
              }                                                  
        }
    `)


   let extraSubmenus = [
       {
            submenu_items: false,
            submenuDataSourceName: 'transcoding'
       },

       {
            submenu_items: false,
            submenuDataSourceName: 'streaming'
       },     
       
       {
            submenu_items: false,
            submenuDataSourceName: 'cdn'
       },            
   ]

   extraSubmenus.forEach(({submenu_items, submenuDataSourceName}, index) => {
    let nodeJSON = data.allApiJson.edges.filter( ({node}) => node.name === submenuDataSourceName)[0] 
    let contentJSON = nodeJSON.node.content
    let linkAndId = contentJSON.map(({menu_title, title}) => {
        return {
            text: menu_title,
            id: title.toLowerCase().split(' ').join('-')
        }
    })

    let apiReferenceTranscodingNode = data.allMdx.edges.filter(({node}) => node.fields.slug === `/api-reference/${submenuDataSourceName}/`)[0].node

    if(apiReferenceTranscodingNode ){
        let { items } = apiReferenceTranscodingNode.tableOfContents
        let pageLinks = []
        if(items){
            pageLinks = items
        }
        pageLinks.forEach(link => {
            linkAndId.push({
                text: link.title,
                id: link.url.substring(1) // remove # as it will be added later
            })
        })
    }        

    extraSubmenus[index].submenu_items = linkAndId.map( (item, index) => {
        
        return(
            <li key={index}>
                <a
                    data-menu-item='submenu'
                    href={`/api-reference/${submenuDataSourceName}/#${item.id}`}
                >
                    {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.6998 3.9998C2.6998 3.6132 2.3864 3.2998 1.9998 3.2998C1.61321 3.2998 1.2998 3.6132 1.2998 3.9998V6.08694C1.2998 8.13039 2.95635 9.78693 4.9998 9.78693H10.3003V11.5048C10.3003 11.5825 10.2982 11.6551 10.2961 11.7234C10.2867 12.0426 10.28 12.2696 10.5052 12.4948C10.7785 12.7681 11.2218 12.7681 11.4951 12.4948L14.4951 9.49478C14.7685 9.22141 14.7685 8.7782 14.4951 8.50483L11.4951 5.50483C11.2218 5.23146 10.7785 5.23146 10.5052 5.50483C10.2814 5.72862 10.2867 5.91785 10.296 6.25058C10.2981 6.3243 10.3003 6.40505 10.3004 6.49478L10.3003 8.38694H4.9998C3.72955 8.38694 2.6998 7.35719 2.6998 6.08694V3.9998Z" fill="#67717B"/>
                    </svg> */}
                    <span>{item.text}</span>
                </a>
            </li>
        )
    })  


   })

   //console.log("extraSubmenus: ", extraSubmenus)


    // check URL against List of URL, it is unique if we find it only once
    function isUrlUniqueInUrlsList(url, urlList){
        let counter = -1
        urlList.forEach(item => {
            if(item.includes(url)){
                counter++
            }
        })
        return !counter
    }    

    function findAllSectionPostsInList(section, nodes){
        // posts will have matching urls /Tutorials/Storage/Qencode-Storage/  
        let posts = nodes.map(( {url, name} ) => {
            return {
                dir: url,
                name
            }
        })
        posts = posts.filter( ({ dir }) => dir.includes(section) && dir !== section)   
        
        // replace  "/Tutorials/Storage/Third-Party-Storage/microsoft-azure/" with "microsoft-azure"
        posts = posts.map(({ dir, name }) => {
            dir = dir.slice(1, -1).split('/')[3]
            return {
                dir: dir,
                name
            }
        })
            
        return posts
    }      


    let menu_from_data = []   

    let urlList = []

    let nodes = data.allMdx.edges.map( ({ node }) => {
        // console.log(node.fields.slug)
        urlList.push(node.fields.slug)
        return {
            url: node.fields.slug,
            name: node.frontmatter.dir
        } 
    })      

    // add top level Docs first
    nodes.forEach( ({ url, name }) => {
        let urlArray = url.slice(1, -1).split('/')
        if(urlArray.length === 1){
            menu_from_data.push({
                "name": name,
                "dir": urlArray[0],
                "categories":[]             
            })
        }
    })   
    
    // add categories
    nodes.forEach( ({ url, name }) => {
        let urlArray = url.slice(1, -1).split('/')
        if(urlArray.length === 2){
            // find relevant Doc and add categories in there 
            menu_from_data.forEach(({ dir }, index) => {
                if(urlArray[0] === dir){
                    menu_from_data[index].categories.push({
                        "name": name,
                        "dir": urlArray[1],
                        "sections":[],
                        "posts":[]
                    })
                }
                
            })
        }
    })      


    // add sections[] and posts[] inside categories
    nodes.forEach( ({ url, name }) => {
        let urlArray = url.slice(1, -1).split('/')
        if(urlArray.length === 3){
            // if this part of URL is unique in URL list, this is POST
            // otherwise this is sectio
            // if URL is unique in the URLs list, push it to posts array of their category
 
            if(isUrlUniqueInUrlsList(url, urlList)){
                // find relevant Doc
                menu_from_data.forEach(({ dir }, index) => {
                    if(urlArray[0] === dir){
                        // find relevant category
                        menu_from_data[index].categories.forEach((category) => {
                            if(category.dir === urlArray[1]){
                                category.sections.push({
                                    "name": name,
                                    "dir": urlArray[2],
                                    posts:[]
                                })
                            }
                        })
                    }                     
                })      
            } else{
                // find all posts relvant to this section and add them also      
                let posts = []
                posts = findAllSectionPostsInList(url, nodes)

                // this is a name of section, push it to the array of sections
                // find relevant Doc
                menu_from_data.forEach(({ dir }, index) => {
                    if(urlArray[0] === dir){
                        // find relevant category
                        menu_from_data[index].categories.forEach((category) => {
                            if(category.dir === urlArray[1]){          
                                category.sections.push({
                                    "name": name,
                                    "dir": urlArray[2],
                                    posts: posts
                                })                                
                            }
                        })
                    }                     
                }) 
            }    
  
        }
    })    

    

    // remove index page from top level docs
    menu_from_data = menu_from_data.filter(({ dir }) => dir !=='');

    // BUILDING UI
    // menu is sorted by 'weight' from md file frontmatter by Graphql request
    const menu = menu_from_data
    // console.log("menu", menu);
    
    // TODO
    // need to associate top level articles with images

    // <img src={`/gatsby-docs/images/docs/${item.dir}.svg`} alt={item.dir} />
    // <img src="/images/docs/tutorials.svg" alt="Tutorials" />

    // const prefixedURL = getPrefixedPath("/images/docs/tutorials.svg")
    // console.log("prefixedURL: ", prefixedURL)

    // const prefixedURL = withPrefix(`/images/docs/tutorials.svg`)
    // console.log("prefixedURL: ", prefixedURL)


    // const bookmark = (
    //     <div className={sidebarStyles.bookmark}>          
    //         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512.02"><defs></defs><path d="M362.68,0H149.34A53.33,53.33,0,0,0,96,53.33v448a10.67,10.67,0,0,0,18.22,7.56L256,367.08,397.79,508.86A10.67,10.67,0,0,0,416,501.33v-448A53.33,53.33,0,0,0,362.68,0Z" transform="translate(-96.01 0)"/></svg>
    //     </div>
    // )
   

    //let menu_items = menu.map( (item, index) => 
    // let menu_items = menu_from_data.map( (item, index) => 
    let menu_items = menu.map( (item, index) => 
        <li key={index}>
            <Link 
                to={`/${item.dir}/`}

                activeClassName={activeStyle}
      
                className = {
                    (item.categories.length > 0)
                    ? `${docStyle} ${hasItemsStyle}`
                    : `${docStyle}` 
                }                  
                

                partiallyActive={true}
            >
                <img src={withPrefix(`/images/docs/${item.dir}.svg`)} alt={item.dir} />

                <div>{item.name}</div>
            </Link>      


            <ul className={`${sectionStyle} ${categoriesStyle}`}>
                {item.categories.map((category, index) => (
                    <li key={index}>
                        <Link 
                            to={`/${item.dir}/${category.dir}/`} // as all is open, disable it as link

                            activeClassName={activeStyle}
                            
                            //className = {`${sidebarStyles.category} ${activeStyle}`} // open all second level menu items
                            // className = {sidebarStyles.category}

                            // className = {
                            //     (item.categories.length > 0)
                            //     ? `${categoryStyle} ${hasItemsStyle}`
                            //     : `${categoryStyle}` 
                            // }             
                                 
                            
                            getProps={({ isPartiallyCurrent, isCurrent }) => {
                                // Start with the base class
                                let className = categoryStyle;
                            
                                // If there are items, add the hasItemsStyle class
                                if (item.categories.length > 0) {
                                  className += ` ${hasItemsStyle}`;
                                }
                            
                                // If the link is exactly active, add the activeStyle
                                // if (isCurrent) {
                                //   className += ` ${activeStyle}`;
                                // }
                            
                                // If the link is partially active, add the partiallyActiveStyle
                                // We check for isPartiallyCurrent to ensure it does not apply when the link is exactly active
                                if (isPartiallyCurrent && !isCurrent) {
                                  className += ` ${partiallyActiveStyle}`;
                                }
                            
                                // If the link is partially active, we will also add the activeStyle
                                // This ensures that activeStyle is applied both when the link is exactly active
                                // and when it is partially active
                                if (isPartiallyCurrent) {
                                  className += ` ${activeStyle}`;
                                }
                            
                                return { className };
                            }}                           

                            partiallyActive={true}
                        >
                            {category.name}
                        </Link>   


                        <ul className={`${sectionStyle} ${sectionsStyle}`}>   
                            
                            {/* {
                                extraSubmenus.map((submenu, index) => 
                                    <Fragment key={index}>
                                        {
                                            submenuDataSourceName && submenu.submenu_items.length > 0 && `/${item.dir}/${category.dir}/` === `/api-reference/${submenu.submenuDataSourceName}/` && submenu.submenu_items
                                        }
                                    </Fragment>
                                )
                            } */}

                            {
                                extraSubmenus.map((submenu, index) => 
                                    <Fragment key={index}>
                                        {
                                            `/${item.dir}/${category.dir}/` === `/api-reference/${submenu.submenuDataSourceName}/` && submenu.submenu_items
                                        }
                                    </Fragment>
                                )
                            }                            

                                      
                            {category.sections.map((section, index) => (

                                <li key={index}>
                                    {/* {

                                        section.posts.length > 0
                                        ?
                                        <Link 
                                            to={`/${item.dir}/${category.dir}/${section.dir}/`}
                                            activeClassName={`${activeStyle} ${hasPostsStyle}`}                                         
                                            partiallyActive={true}                                                                                                           
                                        >
                                            <span>{section.name}</span>
                                        </Link>       
                                        :
                                        <Link 
                                            to={`/${item.dir}/${category.dir}/${section.dir}/`}
                                            activeClassName={activeStyle}
                                            partiallyActive={true}                                        
                                        >
                                            <span>{section.name}</span>
                                        </Link>                                                                                  
                                    } */}

                                    <Link 
                                        to={`/${item.dir}/${category.dir}/${section.dir}/`}
                                        activeClassName={section.posts.length > 0 ? `${activeStyle} ${hasPostsStyle}` : activeStyle}
                                        getProps={({ isPartiallyCurrent, isCurrent }) => {
                                            // Start with the base class. If there are items, add the hasItemsStyle class.
                                            let className = section.posts.length > 0 ? `${hasItemsStyle}` : '';
                                            
                                            // If the link is partially active, add the partiallyActiveStyle.
                                            // We check for isPartiallyCurrent to ensure it does not apply when the link is exactly active.
                                            if (isPartiallyCurrent && !isCurrent) {
                                              className += ` ${partiallyActiveStyle}`;
                                            }
                                        
                                            // // If the link is exactly active, add the activeStyle.
                                            // // This ensures that activeStyle is applied both when the link is exactly active
                                            // // and when it is partially active.
                                            // if (isCurrent) {
                                            //   className += ` ${activeStyle}`;
                                            // }

                                            // If the link is partially active, we will also add the activeStyle
                                            // This ensures that activeStyle is applied both when the link is exactly active
                                            // and when it is partially active
                                            if (isPartiallyCurrent) {
                                                className += ` ${activeStyle}`;
                                            }                                            
                                        
                                            return { className };
                                        }}
                                        partiallyActive={true}
                                    >
                                        <span>{section.name}</span>
                                    </Link>

                                    {
                                        section.posts.length > 0 &&

                                        <ul className={`${sectionStyle} ${postsStyle}`}>                            
                                            {section.posts.map((post, index) => (
                                                <li key={index}>
                                                    <Link 
                                                        to={`/${item.dir}/${category.dir}/${section.dir}/${post.dir}/`}
                                                        activeClassName={activeStyle}                                                     
                                                    >
                                                        {post.name}
                                                    </Link>   
                                                </li>
                                            ))}                            
                                        </ul>                                           

                                    }

                                 

                                </li>
                            ))}

                            {/* {category.posts.map((post, index) => (
                                <li key={index} data-weight={post.weight}>
                                    <Link 
                                        to={`/${item.dir}/${category.dir}/${post.dir}/`}
                                        activeClassName={activeStyle}                                       
                                    >
                                        {post.name}
                                    </Link>   
                                </li>
                            ))}           */}


                        </ul>

                    </li>
                ))}
            </ul>

        </li>        
    )    



    // let isInViewport = (elem) => {

    //     let bounding = elem.getBoundingClientRect();
    //     return (
    //         bounding.top >= 0 && bounding.bottom <= (window.innerHeight*0.5 || document.documentElement.clientHeight)
    //     );
    // };    

    // const debounce = (func, timeout = 0) => {
    //     let timer;
    //     return (...args) => {
    //       clearTimeout(timer);
    //       timer = setTimeout(() => { func.apply(this, args); }, timeout);
    //     };
    // }    
  
    

    useEffect(() => {

        const scrollHandler = () => {

            let isInViewport = (title, allHeaders) => {

                // the closest abs to y = 0 is the current selected title and it must be visible
        
                //let bounding = title.getBoundingClientRect();

                // // find index of closest to 0
                // let currentTitleAbs = Math.abs(bounding.y)

                let allTitlesPostions = []
                allHeaders.forEach(element => {
                    let position = element.getBoundingClientRect();
                    // allTitlesPostions.push(Math.abs(position.y))
                    let positionY = position.y - (window.innerHeight*0.5)
                    if(positionY < 0) {
                        allTitlesPostions.push(position.y - (window.innerHeight*0.5))
                    }
                })
                // console.log("title.id: ", title.id)
                // console.log("allTitlesPostions: ", allTitlesPostions)

                let maxY = Math.max(...allTitlesPostions);
                //console.log("maxY: ", maxY)       
                
                let maxIndex = allTitlesPostions.indexOf(maxY);
                //console.log("maxIndex: ", maxIndex)    

                if(maxIndex >= 0){
                    return allHeaders[maxIndex].id === title.id
                } else {
                    return false
                }
                
                //return allHeaders[maxIndex].id === title.id

                // find closest to 0 among negative
                // if there are no negatives, find closest to 0 among positives

                // let minY = Math.min(...allTitlesPostions);
                // console.log("minY: ", minY)

                // let minIndex = allTitlesPostions.indexOf(minY);
                // console.log("minIndex: ", minIndex)


                // return allHeaders[minIndex].id === title.id

                //return (allHeaders[minIndex].id === title.id) && (bounding.top >= 0 && bounding.bottom <= (window.innerHeight*0.5 || document.documentElement.clientHeight))

                // return (
                //     bounding.top >= 0 && bounding.bottom <= (window.innerHeight*0.5 || document.documentElement.clientHeight)
                // );


            };               

            let allHeaders = document.querySelectorAll('h2')

            let allSubmenuElements = document.querySelectorAll("[data-menu-item='submenu']")

            //console.log("allSubmenuElements: ", allSubmenuElements);

            let currentPageElement = document.querySelector("[aria-current='page']")
            //console.log("currentPageElement: ", currentPageElement)

            //console.log("allHeaders: ", allHeaders);

            allHeaders.forEach(title => {

                if (isInViewport(title, allHeaders)){
                    //console.log("title.id: ", title.id);
                    // let allSubmenuElements = document.querySelectorAll("[data-menu-item='submenu']")

                    // console.log("allSubmenuElements: ", allSubmenuElements);

                    //console.log(" allSubmenuElements[0].href ",  allSubmenuElements[0].href)

                    if (allSubmenuElements && allSubmenuElements.length > 0){

                        allSubmenuElements.forEach(element => {
                            element.className = ''
                        })

                        try {

                            // console.log("submenuDataSourceName: ", submenuDataSourceName);
                            // href="/api-reference/streaming/#creating-a-live-stream"

                            // find related menu item
                            //let domElement = [...allSubmenuElements].filter(element => element.href.split('#')[1] === title.id)[0];
                            let domElement = [...allSubmenuElements].filter(element => element.href.endsWith(`${submenuDataSourceName}/#${title.id}`))[0];

                            domElement.className = activeStyle          
                            // add partially active style here one time
                            // partiallyActiveStyle
                            if (currentPageElement && !currentPageElement.classList.contains(partiallyActiveStyle)) {
                                currentPageElement.classList.add(partiallyActiveStyle);
                            }
                            
                        } catch (error) {
                            console.log("error: ", error);
                        }

                        // let domElement = document.querySelector(`[href='#${title.id}']`)

                        // domElement.className = activeStyle
                    }
                }
            })
            
        }

        //const processChange = debounce(() => scrollHandler());

        if(postLink === '/api-reference/transcoding/' || postLink === '/api-reference/streaming/' || postLink === '/api-reference/cdn/'){
            //console.log("Add on scroll event listenter")
            document.addEventListener("scroll", scrollHandler)
            //document.addEventListener("scroll", processChange)
        }
        
        //document.addEventListener("scroll", scrollHandler)

        // these functions clean up the event listeners
        return () => document.removeEventListener("scroll", scrollHandler)
        //return () => document.removeEventListener("scroll", processChange)
    }, [postLink, submenuDataSourceName])      

    // return (
    //     <div className={isOpen ? `${menuStyle} ${mobileOpenStyle}` : menuStyle} >
    //         <nav className={contentStyle}>
    //             <ul>{menu_items}</ul>
    //         </nav>
    //     </div>
    // )

    return (
        <div className={isOpen ? `${menuStyle} ${mobileOpenStyle}` : menuStyle} >
            <div className={headerStyle}>
                <div className={headerTopStyle}>
                    <Link to='/'>
                        <img className={logoStyle} src={logo} alt="Qencode" />
                    </Link>  
                    <div className={hamburgerStyle}>
                        <Hamburger 
                            id='hamburger'
                            toggled={isOpen} toggle={setOpen} 
                            duration={0.1}
                            color="#2b6cf2"
                        />
                    </div>
                </div>
                <div className={headerSearchStyle}>
                    <Search jsonDataSource={data.allApiJson} />    
                </div>                                               
            </div>
            <nav className={contentStyle}>
                <ul>{menu_items}</ul>
            </nav>
        </div>
    )
}









